export default __webpack_public_path__ + "static/media/delete.fd925f1d.svg";